import type { WorksheetId } from 'cadenza/workbook/api/worksheet-id';
import type { ConditionDto } from 'cadenza/workbook/model/condition-dto';
import type { ConditionGroupId } from 'cadenza/workbook/model/condition-group-id.gen';
import type { ConditionId } from 'cadenza/workbook/model/condition-id.gen';

export type ConditionGroupStatus = 'VALID' | 'NO_VALUE_SET';

/**
 * A condition group
 *
 * @see net/disy/cadenza/workbook/web/dto/ConditionGroupDto.java
 */
export interface ConditionGroupDto {
  id: ConditionGroupId;
  /** Print name */
  name: string;
  collapsed: boolean;
  mandatory: boolean;
  conditions: ConditionId[];
  statusByWorksheetId: Record<WorksheetId, ConditionGroupStatus>;
}

export function isConditionGroup(cond: ConditionDto | ConditionGroupDto): cond is ConditionGroupDto {
  return 'conditions' in cond && !!cond.conditions;
}
